import { render, staticRenderFns } from "./ColumnInfo.vue?vue&type=template&id=d5730560&scoped=true"
import script from "./ColumnInfo.vue?vue&type=script&lang=js"
export * from "./ColumnInfo.vue?vue&type=script&lang=js"
import style0 from "./ColumnInfo.vue?vue&type=style&index=0&id=d5730560&prod&lang=css"
import style1 from "./ColumnInfo.vue?vue&type=style&index=1&id=d5730560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5730560",
  null
  
)

export default component.exports